// Mock data for Skandrix website

export const services = [
  {
    id: 1,
    title: "IT & Tech Solutions",
    description: "End-to-end technology development that scales with your business vision.",
    icon: "Code2"
  },
  {
    id: 2,
    title: "Startup Growth Services",
    description: "From pre-seed to Series A and beyond — strategic guidance at every stage.",
    icon: "Rocket"
  },
  {
    id: 3,
    title: "Business Consulting",
    description: "Strategic insights that connect technology decisions to business outcomes.",
    icon: "Lightbulb"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Understand before we build",
    description: "We invest time in comprehending your business, market, and objectives before writing a single line of code."
  },
  {
    id: 2,
    title: "Guide before we execute",
    description: "Strategic direction comes first. We align technology with your growth trajectory."
  },
  {
    id: 3,
    title: "Deliver for impact",
    description: "Every solution is designed to create measurable business value, not just technical excellence."
  }
];

export const impactStories = [
  {
    id: 1,
    title: "Concept to Funding",
    description: "Transformed a founder's vision into a funded MVP in 90 days.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Tech Scaling Success",
    description: "Rebuilt infrastructure to support 10x user growth without downtime.",
    image: "https://images.unsplash.com/photo-1600605836700-1aa27955927b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Strategy-Led Growth",
    description: "Connected market insights to product roadmap, accelerating Series A timeline.",
    image: "https://images.unsplash.com/photo-1627364881795-1fb86fcf2e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const comparison = [
  {
    common: "Build what you ask for",
    skandrix: "Challenge assumptions, build what you need"
  },
  {
    common: "Deliver on time and budget",
    skandrix: "Deliver for impact and scalability"
  },
  {
    common: "Follow latest tech trends",
    skandrix: "Choose technology based on business strategy"
  },
  {
    common: "Hand over the code",
    skandrix: "Partner through growth phases"
  }
];

export const techServices = [
  {
    id: 1,
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications that users love and businesses scale. Build cutting-edge mobile solutions for iOS and Android.",
    detailedDescription: "Transform your business idea into a powerful mobile application. We specialize in creating intuitive, high-performance apps that engage users and drive business growth. From consumer apps to enterprise solutions, we deliver mobile experiences that matter.",
    benefits: [
      "Native iOS & Android development",
      "Cross-platform solutions (React Native, Flutter)",
      "App Store & Play Store optimization",
      "Push notifications & real-time features",
      "Offline functionality & data sync",
      "Payment gateway integration"
    ],
    techStack: ["React Native", "Flutter", "Swift", "Kotlin", "Firebase"],
    process: [
      "Discovery & Strategy",
      "UX Design & Prototyping",
      "Agile Development",
      "Quality Assurance",
      "Launch & Support"
    ],
    icon: "Smartphone"
  },
  {
    id: 2,
    title: "Web Application Development",
    description: "High-performance web applications built with modern frameworks. Scalable, secure, and optimized for conversions.",
    detailedDescription: "Create powerful web applications that drive your business forward. We build responsive, fast, and scalable web solutions using cutting-edge technologies. From MVPs to enterprise platforms, we deliver web experiences that convert.",
    benefits: [
      "Modern frontend frameworks (React, Next.js)",
      "Robust backend architecture",
      "RESTful & GraphQL APIs",
      "Real-time data processing",
      "Progressive Web Apps (PWA)",
      "SEO optimization built-in"
    ],
    techStack: ["React", "Next.js", "Node.js", "TypeScript", "PostgreSQL"],
    process: [
      "Architecture Planning",
      "Frontend Development",
      "Backend Integration",
      "Performance Optimization",
      "Deployment & Monitoring"
    ],
    icon: "Globe"
  },
  {
    id: 3,
    title: "Cloud Infrastructure & DevOps",
    description: "Scalable cloud infrastructure and automated workflows. Build, deploy, and scale with confidence on AWS, Azure, or GCP.",
    detailedDescription: "Move to the cloud and scale effortlessly. We design and implement cloud-native architectures that reduce costs, improve reliability, and enable rapid scaling. Our DevOps practices ensure continuous delivery and zero-downtime deployments.",
    benefits: [
      "Cloud migration & optimization",
      "CI/CD pipeline automation",
      "Infrastructure as Code (IaC)",
      "Container orchestration (Docker, Kubernetes)",
      "Auto-scaling & load balancing",
      "24/7 monitoring & alerting"
    ],
    techStack: ["AWS", "Azure", "GCP", "Docker", "Kubernetes", "Terraform"],
    process: [
      "Infrastructure Design",
      "CI/CD Pipeline Setup",
      "Cloud Migration",
      "Security Hardening",
      "Cost Optimization"
    ],
    icon: "Cloud"
  },
  {
    id: 4,
    title: "AI & Machine Learning Solutions",
    description: "Intelligent systems powered by AI and ML. Turn your data into actionable insights and automated decisions.",
    detailedDescription: "Harness the power of artificial intelligence to transform your business. From predictive analytics to natural language processing, we build AI solutions that automate workflows, enhance decision-making, and create competitive advantages.",
    benefits: [
      "Custom ML model development",
      "Natural Language Processing (NLP)",
      "Computer vision & image recognition",
      "Recommendation engines",
      "Predictive analytics & forecasting",
      "Chatbots & virtual assistants"
    ],
    techStack: ["TensorFlow", "PyTorch", "OpenAI", "LangChain", "Python", "Hugging Face"],
    process: [
      "Use Case Analysis",
      "Data Pipeline & Preparation",
      "Model Development & Training",
      "Integration & Deployment",
      "Monitoring & Iteration"
    ],
    icon: "Brain"
  },
  {
    id: 5,
    title: "E-Commerce Solutions",
    description: "Complete e-commerce platforms that drive sales. From product catalogs to payment processing, we build online stores that convert.",
    detailedDescription: "Launch and scale your online business with our comprehensive e-commerce solutions. We create seamless shopping experiences with integrated payments, inventory management, and marketing tools that drive revenue growth.",
    benefits: [
      "Custom storefront design",
      "Multi-vendor marketplace support",
      "Payment gateway integration",
      "Inventory & order management",
      "Analytics & conversion tracking",
      "Mobile-responsive checkout"
    ],
    techStack: ["Shopify", "WooCommerce", "Magento", "Stripe", "PayPal"],
    process: [
      "Store Strategy & Planning",
      "Design & Development",
      "Payment Integration",
      "Testing & Launch",
      "Marketing & Optimization"
    ],
    icon: "ShoppingCart"
  },
  {
    id: 6,
    title: "UI/UX Design Services",
    description: "Beautiful, intuitive interfaces that users love. Design systems, prototypes, and user research that drive engagement.",
    detailedDescription: "Create memorable user experiences that drive business results. Our design team combines user research, visual design, and interaction design to craft interfaces that are both beautiful and functional.",
    benefits: [
      "User research & persona development",
      "Wireframing & prototyping",
      "Visual design & branding",
      "Design system creation",
      "Usability testing",
      "Accessibility (WCAG) compliance"
    ],
    techStack: ["Figma", "Adobe XD", "Sketch", "InVision", "Framer"],
    process: [
      "User Research",
      "Wireframing",
      "Visual Design",
      "Prototyping",
      "Usability Testing"
    ],
    icon: "Palette"
  },
  {
    id: 7,
    title: "API Development & Integration",
    description: "Robust APIs that power your applications. RESTful, GraphQL, and WebSocket APIs built for scale and reliability.",
    detailedDescription: "Connect your systems and enable seamless data flow with our API development services. We design and build APIs that are secure, scalable, and well-documented, making integration effortless.",
    benefits: [
      "RESTful API design & development",
      "GraphQL implementation",
      "Third-party API integration",
      "API documentation (Swagger/OpenAPI)",
      "Rate limiting & security",
      "Webhook implementation"
    ],
    techStack: ["Node.js", "Express", "GraphQL", "REST", "Postman", "Swagger"],
    process: [
      "API Design & Planning",
      "Development & Testing",
      "Documentation",
      "Integration Support",
      "Monitoring & Maintenance"
    ],
    icon: "Workflow"
  },
  {
    id: 8,
    title: "Quality Assurance & Testing",
    description: "Comprehensive testing strategies that ensure reliability. Automated tests, manual QA, and performance testing.",
    detailedDescription: "Deliver bug-free software with our comprehensive QA services. We implement automated testing, manual QA, and continuous testing practices to ensure your application performs flawlessly.",
    benefits: [
      "Automated test suite development",
      "Manual exploratory testing",
      "Performance & load testing",
      "Security testing",
      "Cross-browser compatibility",
      "Mobile device testing"
    ],
    techStack: ["Selenium", "Jest", "Cypress", "Playwright", "JMeter", "Postman"],
    process: [
      "Test Strategy Development",
      "Automated Testing",
      "Manual QA",
      "Performance Testing",
      "Continuous Monitoring"
    ],
    icon: "CheckCircle"
  },
  {
    id: 9,
    title: "Cybersecurity Services",
    description: "Protect your business from threats. Security audits, penetration testing, and compliance implementation.",
    detailedDescription: "Safeguard your digital assets with enterprise-grade security. We conduct thorough security audits, implement best practices, and ensure compliance with industry standards.",
    benefits: [
      "Security audits & assessments",
      "Penetration testing",
      "Compliance (GDPR, HIPAA, SOC2)",
      "Vulnerability scanning",
      "Incident response planning",
      "Security training for teams"
    ],
    techStack: ["OWASP", "Burp Suite", "Metasploit", "Wireshark", "AWS Security"],
    process: [
      "Security Assessment",
      "Threat Modeling",
      "Implementation",
      "Testing & Validation",
      "Ongoing Monitoring"
    ],
    icon: "Shield"
  },
  {
    id: 10,
    title: "Data Analytics & BI",
    description: "Turn data into insights. Business intelligence dashboards, data warehousing, and predictive analytics.",
    detailedDescription: "Make data-driven decisions with our analytics and BI solutions. We help you collect, process, and visualize data to uncover insights that drive business growth.",
    benefits: [
      "Custom dashboard development",
      "Data warehouse implementation",
      "Real-time analytics",
      "Predictive modeling",
      "ETL pipeline development",
      "Data visualization"
    ],
    techStack: ["Tableau", "Power BI", "Python", "SQL", "Apache Spark", "Snowflake"],
    process: [
      "Data Strategy",
      "Pipeline Development",
      "Dashboard Design",
      "Implementation",
      "Training & Support"
    ],
    icon: "BarChart"
  },
  {
    id: 11,
    title: "ERP & CRM Solutions",
    description: "Enterprise software that streamlines operations. Custom ERP and CRM systems tailored to your business processes.",
    detailedDescription: "Optimize your business operations with custom ERP and CRM solutions. We implement and customize enterprise software that aligns with your unique workflows and scales with your growth.",
    benefits: [
      "Process automation",
      "Custom workflow design",
      "Integration with existing systems",
      "Reporting & analytics",
      "Mobile access",
      "Training & change management"
    ],
    techStack: ["SAP", "Salesforce", "Odoo", "Microsoft Dynamics", "Custom Solutions"],
    process: [
      "Requirements Analysis",
      "System Selection",
      "Customization & Implementation",
      "Training",
      "Ongoing Support"
    ],
    icon: "Building"
  },
  {
    id: 12,
    title: "Blockchain Development",
    description: "Decentralized solutions for the future. Smart contracts, DApps, and blockchain integration.",
    detailedDescription: "Build trust and transparency with blockchain technology. We develop smart contracts, decentralized applications, and blockchain integrations that create new business models.",
    benefits: [
      "Smart contract development",
      "DApp creation",
      "NFT marketplace development",
      "Cryptocurrency integration",
      "Private blockchain networks",
      "Blockchain consulting"
    ],
    techStack: ["Ethereum", "Solidity", "Web3.js", "Hardhat", "IPFS"],
    process: [
      "Blockchain Strategy",
      "Smart Contract Development",
      "Testing & Auditing",
      "Deployment",
      "Maintenance"
    ],
    icon: "Link"
  }
];

export const startupStages = [
  {
    id: 1,
    stage: "Pre-Seed",
    title: "From Idea to Validation",
    description: "Transform your vision into a tangible product that attracts early believers.",
    services: [
      "Concept validation & market research",
      "MVP development & rapid prototyping",
      "Early user testing & feedback loops",
      "Pitch deck & investor storytelling",
      "Strategic network introductions"
    ]
  },
  {
    id: 2,
    stage: "Seed",
    title: "Building Momentum",
    description: "Scale your validated idea into a product-market fit powerhouse.",
    services: [
      "Product-market fit optimization",
      "Growth infrastructure setup",
      "Team building & technical leadership",
      "Metrics dashboard & analytics",
      "Fundraising strategy & investor network"
    ]
  },
  {
    id: 3,
    stage: "Series A",
    title: "Scaling Excellence",
    description: "Build the foundation for exponential growth without breaking.",
    services: [
      "Architecture redesign for scale",
      "Operations automation",
      "Advanced analytics & BI",
      "Security & compliance framework",
      "Strategic partnerships & integrations"
    ]
  },
  {
    id: 4,
    stage: "Beyond Growth",
    title: "Sustaining Leadership",
    description: "Maintain competitive edge while scaling to market dominance.",
    services: [
      "Innovation lab & R&D",
      "M&A technical due diligence",
      "Global expansion infrastructure",
      "AI & ML integration",
      "Enterprise transformation"
    ]
  }
];

export const whySkandirix = [
  {
    point: "We don't just code — we understand business context"
  },
  {
    point: "Access to strategic networks and industry experts"
  },
  {
    point: "Technology decisions aligned with growth trajectory"
  },
  {
    point: "Long-term partnership, not transactional projects"
  }
];

export const videos = [
  {
    id: 1,
    title: "From Zero to Seed: A Founder's Journey",
    description: "Watch how a first-time founder transformed an idea into a funded startup in 6 months with strategic guidance.",
    thumbnail: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85",
    duration: "8:45",
    category: "Pre-Seed",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  },
  {
    id: 2,
    title: "Scaling Infrastructure for 10x Growth",
    description: "Technical deep-dive into rebuilding a startup's architecture to handle exponential user growth without downtime.",
    thumbnail: "https://images.unsplash.com/photo-1600605836700-1aa27955927b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85",
    duration: "12:30",
    category: "Series A",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  },
  {
    id: 3,
    title: "Product-Market Fit: Signs You've Found It",
    description: "Learn the key indicators that show your startup has achieved product-market fit and what to do next.",
    thumbnail: "https://images.unsplash.com/photo-1627364881795-1fb86fcf2e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85",
    duration: "15:20",
    category: "Seed",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  },
  {
    id: 4,
    title: "Pitch Deck Masterclass for Tech Startups",
    description: "What investors actually look for in pitch decks. Real examples from successful fundraising rounds.",
    thumbnail: "https://images.unsplash.com/photo-1643236694409-1107518b435a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA1Mzc2ODV8MA&ixlib=rb-4.1.0&q=85",
    duration: "18:15",
    category: "Pre-Seed",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  },
  {
    id: 5,
    title: "Building Your MVP: What to Include and What to Skip",
    description: "Strategic approach to MVP development - focus on features that validate your hypothesis, not impress users.",
    thumbnail: "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3MDUzNzY4MHww&ixlib=rb-4.1.0&q=85",
    duration: "10:55",
    category: "Pre-Seed",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  },
  {
    id: 6,
    title: "Technical Due Diligence: What Series A Investors Check",
    description: "Prepare your codebase and infrastructure for investor scrutiny. Common red flags and how to avoid them.",
    thumbnail: "https://images.unsplash.com/photo-1631727498532-b27e7f9796ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxtaW5pbWFsJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3MDUzNzY4MHww&ixlib=rb-4.1.0&q=85",
    duration: "14:40",
    category: "Series A",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  }
];

export const videoCategories = ["All", "Pre-Seed", "Seed", "Series A", "Growth"];
